import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { faFileImage } from '@fortawesome/pro-light-svg-icons';
import { faShirtExpand, faImageCirclePlus } from '@awesome.me/kit-4c37f718d5/icons/kit/custom';
/* add icons to the library */

library.add(faFileImage);
library.add(fas);
library.add(far);
library.add(faShirtExpand, faImageCirclePlus);

Vue.component('font-awesome-icon', FontAwesomeIcon);
